import { clsx } from 'clsx';

import { ISbStoryData } from 'storyblok-js-client';

import { createPropsForImage } from '@monoimin/utils/props-creators';
import { LicenseStoryblok, Locales } from '@monoimin/sb-types';
import { Typography, UniversalImage } from '@monoimin/atoms';
import { getRegionNameByCode } from '@monoimin/utils/formatters';

type LicenseCardProps = {
  data: ISbStoryData<LicenseStoryblok>;
  classNames?: {
    container?: string;
    image?: string;
    title?: string;
    description?: string;
  };
  dataPaginationActive?: boolean;
  locale: Locales;
  onClick?: () => void;
};

export const LicenseCard = ({
  data,
  classNames,
  dataPaginationActive,
  locale,
  onClick,
}: LicenseCardProps) => {
  const { content } = data;

  const { image, description, countryTitle, title } = content;

  const imageProps = createPropsForImage(image);

  return (
    <div
      onClick={onClick}
      data-pagination-active={dataPaginationActive}
      className={clsx('flex flex-col relative', classNames?.container)}
    >
      {imageProps && (
        <UniversalImage
          pattern='dimensions'
          width={imageProps.width}
          height={imageProps.height}
          src={imageProps.src}
          alt={image?.alt || ''}
          className={clsx(
            'object-contain object-center pointer-events-none',
            classNames?.image
          )}
          quality={100}
        />
      )}
      <Typography className={clsx('body font-bold', classNames?.title)}>
        {title || getRegionNameByCode(locale).of(countryTitle as string)}
      </Typography>
      <Typography className={clsx('body', classNames?.description)}>
        {description}
      </Typography>
    </div>
  );
};

export default LicenseCard;
